import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeUser: null,
};

const userDataSlice = createSlice({
    name: "userData",
    initialState,
    reducers: {
        setActiveUser(state, action) {
            const userData = JSON.parse(localStorage.getItem("userData"));

            if(userData){
                userData.image = action.payload;
                localStorage.setItem("userData", JSON.stringify(userData));

                state.activeUser = userData;
                localStorage.setItem("userData", userData);
            }

        },
    },
});

export const { setActiveUser } = userDataSlice.actions;
export default userDataSlice.reducer;
